"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Upsells/ListMenuNotice.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _WarningBar = require('web/components/WarningBar'); var _WarningBar2 = _interopRequireDefault(_WarningBar);
var _keyboard = require('web/services/keyboard');






const ListMenuUpsellNotice = ({ desc, onRequest }) => (
  _react2.default.createElement('div', { className: "list-menu--upsells", __self: this, __source: {fileName: _jsxFileName, lineNumber: 11}}
    , _react2.default.createElement(_WarningBar2.default, {
      className: "list-menu--upsells--warning",
      text: "This feature is not included in your current plan."        , __self: this, __source: {fileName: _jsxFileName, lineNumber: 12}}
    )
    , _react2.default.createElement('span', { className: "list-menu--upsells--hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 16}},  desc )
    ,  onRequest && (
      _react2.default.createElement('span', {
        role: "button", tabIndex: 0, onKeyDown: _keyboard.onButtonKeyDown,
        className: "list-menu--upsells--access-link",
        onClick: onRequest, __self: this, __source: {fileName: _jsxFileName, lineNumber: 18}}
, "Request access"

      )
    )
  )
)

exports. default = ListMenuUpsellNotice
